export abstract class Base {
  // tslint:disable-next-line:variable-name no-any
  static deserialize(json: any): any {
    throw 'Not implemented';
  }

  abstract serialize(): object;
}
